export const getApproveDvDContent = (t, request) => {
  const { tokenMaker, tokenTaker, counterPartyInvestor, wallet, provider, isCreatedbyMe } = request;

  const tokenToSend = isCreatedbyMe ? tokenMaker : tokenTaker;
  const tokenToReceive = isCreatedbyMe ? tokenTaker : tokenMaker;

  return `<div>
      <div class="_flex:align(center) _m:y(2)">
        ${t('shared.youWill')} ${t('shared.send').toLocaleLowerCase()}
        <strong class="_m:x(1)">${tokenToSend.amount} ${tokenToSend.symbol}</strong>
        ${
          provider === 'ONCHAINID'
            ? t('shared.fromYourOnchainidWallet')
            : t('shared.fromYourWallet')
        }:
        <ds-explorer-link network=${
          tokenMaker.blockchainNetwork
        } address=${wallet} class="_m:x(2)" is-copyable=${false}></ds-explorer-link>
      </div>
      <div class="_flex:align(center) _m:y(2)">${t('shared.toTheWallet')}:
        <ds-explorer-link network=${tokenMaker.blockchainNetwork} address=${
    counterPartyInvestor.address
  } class="_m:x(2)" is-copyable=${false}></ds-explorer-link>
        <span class="_text-grey-900">( <ds-eth-avatar class="_m:right(2)" size="12px" address=${
          counterPartyInvestor.address
        }></ds-eth-avatar> ${counterPartyInvestor.name} )</span>
      </div>
      <div class="_flex:align(center) _m:y(2)">
        ${t('shared.and')} ${t('shared.receive')}
        <strong class="_m:x(1)">${tokenToReceive.amount} ${tokenToReceive.symbol}</strong> ${t(
    'shared.toYourWallet',
  )}. ${t('shared.doYouWantToProceed')}   
      </div>
    </div>`;
};

export const getRejectDvDContent = (t, request) => {
  const { tokenMaker, tokenTaker, counterPartyInvestor, isCreatedbyMe } = request;

  const tokenToSend = isCreatedbyMe ? tokenMaker : tokenTaker;
  const tokenToReceive = isCreatedbyMe ? tokenTaker : tokenMaker;

  return `<div>
      <div class="_flex:align(center) _m:y(2)">
        ${t('shared.youAreAboutToRejectTransferRequest')} 
        <strong class="_m:left(1)">${counterPartyInvestor.name}</strong>
      </div>
      <div class="_flex:align(center) _m:y(2)">
      ${t('shared.toSend')}
        <strong class="_m:x(1)">${tokenToSend.amount} ${tokenToSend.symbol}</strong> ${t(
    'shared.toYourWallet',
  )} ${t('shared.and')} ${t('shared.receive')}
     <strong class="_m:x(1)">${tokenToReceive.amount} ${tokenToReceive.symbol}</strong>
      ${t('shared.fromYourWallet')}.
      </div>
      <div class="_flex:align(center) _m:y(2)">${t('shared.irreversibleAction')} ${t(
    'shared.doYouWantToProceed',
  )}</div>
    </div>`;
};

export const getCancelDvDContent = (t, request) => {
  const { tokenMaker, tokenTaker, counterPartyInvestor, isCreatedbyMe } = request;

  const tokenToSend = isCreatedbyMe ? tokenMaker : tokenTaker;
  const tokenToReceive = isCreatedbyMe ? tokenTaker : tokenMaker;

  return `<div>
      <div class="_flex:align(center) _m:y(2)">
        ${t('shared.youAreAboutToCancelTransferRequest')}
         <strong class="_m:left(1)">${counterPartyInvestor.name}</strong>
      </div>
      <div class="_flex:align(center) _m:y(2)">
      ${t('shared.toSend')}
        <strong class="_m:x(1)">${tokenToSend.amount} ${tokenToSend.symbol}</strong> ${t(
    'shared.fromYourWallet',
  )} ${t('shared.and')} ${t('shared.receive')}
     <strong class="_m:x(1)">${tokenToReceive.amount} ${tokenToReceive.symbol}</strong>
       ${t('shared.toYourWallet')}.
      </div>
      <div class="_flex:align(center) _m:y(2)">${t('shared.irreversibleAction')} ${t(
    'shared.doYouWantToProceed',
  )}</div>
    </div>`;
};
